// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"Logo__logoLink___3398n","logo":"Logo__logo___35NyS","secundary":"Logo__secundary___2vrk_"};